import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MouseIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mouse"}/>
}
